// Config file that contains all urls and keys used throughout the application
// Both development and production objects must have the same keys

const simplifyApiUrl = `${window.location.protocol}//tickets-dev.simplif.ai/`;
const simplifyApiUrlDev = `${window.location.protocol}//tickets-dev.simplif.ai/`;

export const siteId = '1';
export const salesChannelId = '1';

const bId = '1794';
const websiteConfigId = '25100';

const useC3 = true;
const c3CurrencyCode = 'USD';
const c3CheckoutDomain = 'checkout.simplifytickets.com';

const seaticsScriptUrl = `${window.location.protocol}//www.tn-apis.com/maps/v3`;
const policyScriptUrl = `${window.location.protocol}://tickettransaction.com/?bid=${bId}&sitenumber=${siteId}&tid=600&wcid=${websiteConfigId}`;

const googleTagManagerId = 'UA-118586884-2';
const googleOptimizeId = 'GTM-N8CVDTH';

const CONSUMER_KEY = 'DvYDIV_YfYRtAFZzRknTrBfazyUa';

const features = {
  taraSurvey: true,
};

const development = {
  simplifyApiUrl: simplifyApiUrlDev,

  siteId,
  salesChannelId,
  bId,
  websiteConfigId,

  useC3,
  c3CurrencyCode,
  c3CheckoutDomain,

  seaticsScriptUrl,
  policyScriptUrl,

  consumerKey: CONSUMER_KEY, // 'jfbWXNweYqfxFBU75ANEGSv_YoMa',

  googleTagManagerId,
  googleOptimizeId,

  features,
};


const production = {
  ...development,

  simplifyApiUrl,
};

export default process.env.NODE_ENV === 'production' ? production : development;



// WEBPACK FOOTER //
// ./src/config.js